export enum ChatFilter {
  PERSONAL = 'personal',
  EVENTS = 'event',
  MERCHANTS = 'merchant',
  GROUPS = 'group',
}

export function getChatFilterName(filter: ChatFilter): string {
  switch (filter) {
    case ChatFilter.PERSONAL:
      return 'Personal';
    case ChatFilter.GROUPS:
      return 'Groups';
    case ChatFilter.EVENTS:
      return 'Events';
    case ChatFilter.MERCHANTS:
      return 'Merchants';
  }
}
